import { usePortalConfigs } from 'hooks/usePortalConfigs';
import useFeature from 'services/features/useFeature';
import useSubscriptions from 'services/general/subscriptionsList';

export type TinyPlusNavState = {
  showUpgradeCta: boolean;
  showMemberBadge: boolean;
};

export const useTinyPlusNavState = (): TinyPlusNavState => {
  const { isFeatureEnabled: isTinyPlusUpsellMomentsEnabled, variables } =
    useFeature('tiny_plus_upsell_moments');
  const isMembershipEnabled =
    isTinyPlusUpsellMomentsEnabled && Boolean(variables?.enable_membership);
  const { isAnyTinyPlus } = useSubscriptions();
  const { config: portalConfig, isLoading: isPortalConfigLoading } =
    usePortalConfigs();

  const hideUpsells =
    Boolean(portalConfig.hide_upsells) || isPortalConfigLoading;

  return {
    showUpgradeCta: isMembershipEnabled && !isAnyTinyPlus && !hideUpsells,
    showMemberBadge: isMembershipEnabled && isAnyTinyPlus,
  };
};
